const storage = () => import('../views/supplier/list/index.vue')

export default [
    {
        path: '/storage',
        name: 'storage',
        meta: {
            name: '仓库管理',
            keepAlive: true
        },
        redirect: { name: 'commodity-stocks' }
    },
    {
        path: '/stocks-analysis',
        name: 'stocks-analysis',
        meta: {
            name: '商品动销分析',
            keepAlive: true,
            notLayout: true
        },
        component: () => import(/* webpackChunkName: "storage" */'../views/stock-control/stock-analysis/index.vue')
    },
    {
        path: '/commodity-stocks',
        name: 'commodity-stocks',
        meta: {
            name: '商品库存',
            keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "storage" */'../views/stock-control/commodity-stocks/index.vue')
    },
    {
        path: '/storage/out-stock',
        name: 'out-stock',
        meta: {
            name: '出库单',
            keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "storage" */'../views/stock-control/out-stock/index.vue'),
    },
    {
        path: '/storage/out-stock/add',
        name: 'out-stock-add',
        meta: {
            name: '新增出库单',
            backName: 'out-stock',
            keepAlive: true
        },
        component: () => import(/* webpackChunkName: "storage" */'../views/stock-control/out-stock/addOrUpdate.vue'),
    },
    {
        path: '/storage/out-stock/update/:id',
        name: 'out-stock-update',
        meta: {
            name: '编辑出库单',
            backName: 'out-stock',
            keepAlive: true
        },
        component: () => import(/* webpackChunkName: "storage" */'../views/stock-control/out-stock/addOrUpdate.vue'),
    },
    {
        path: '/storage/out-stock/detail/:id',
        name: 'out-stock-detail',
        meta: {
            name: '出库单详情',
            backName: 'out-stock',
            keepAlive: true
        },
        component: () => import(/* webpackChunkName: "storage" */'../views/stock-control/out-stock/orderDetail.vue'),
    },
    {
        path: '/storage/in-stock',
        name: 'in-stock',
        meta: {
            name: '入库单',
            keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "storage" */'../views/stock-control/in-stock/index.vue'),

    },
    {
        path: '/storage/in-stock/add',
        name: 'in-stock-add',
        meta: {
            name: '新增入库单',
            backName: 'ouint-stock',
            keepAlive: true
        },
        component: () => import(/* webpackChunkName: "storage" */'../views/stock-control/in-stock/addOrUpdate.vue'),
    },
    {
        path: '/storage/in-stock/update/:id',
        name: 'in-stock-update',
        meta: {
            name: '编辑入库单',
            backName: 'in-stock',
            keepAlive: true
        },
        component: () => import(/* webpackChunkName: "storage" */'../views/stock-control/in-stock/addOrUpdate.vue'),
    },
    {
        path: '/storage/in-stock/detail/:id',
        name: 'in-stock-detail',
        meta: {
            name: '入库单详情',
            backName: 'in-stock',
            keepAlive: true
        },
        component: () => import(/* webpackChunkName: "storage" */'../views/stock-control/in-stock/orderDetail.vue'),
    },
]
